import { defineMessages } from 'react-intl';

export const navbarTranslations = defineMessages({
  appName: {
    id: 'navbar.appName',
    defaultMessage: 'Process Lifecycle Navigator',
    description: 'App name in navbar',
  },
  logout: {
    id: 'navbar.logout',
    defaultMessage: 'Logout',
    description: 'Logout link in navbar',
  },
  productionEnvironment: {
    id: 'navbar.environment.production',
    defaultMessage: 'Production environment',
    description: 'Production environment text in navbar',
  },
  testEnvironment: {
    id: 'navbar.environment.test',
    defaultMessage: 'Testing environment',
    description: 'Test environment text in navbar',
  },
  developmentEnvironment: {
    id: 'navbar.environment.development',
    defaultMessage: 'Development environment',
    description: 'Development environment text in navbar',
  },
  userInfoRole: {
    id: 'navbar.userInfo.role',
    defaultMessage: 'Role',
    description: 'Role in user info popover',
  },
});
